import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from 'react-router';
import axios from 'axios';
import {URL, PATH, AUTH} from '../config';

let Spell = () => {
  let {spellId} = useParams();
  const [   classString ,   setClassString  ] = useState("");
  const [   tagsString  ,   setTagsString   ] = useState("");
  const [   spellData   ,   setSpellData    ] = useState({
    spellInfo: {
      "spell_id": spellId,
      "spell_name": "",
      "school_id": "",
      "casting_time": "",
      "range": "",
      "area": "",
      "effect": "",
      "targets": "",
      "duration": "",
      "dismissible": "",
      "shapeable": "",
      "saving_throw": "",
      "spell_resist": "",
      "source_id": "",
      "deity_id": "",
      "spell_like_ability_level": "",
      "domain": "",
      "bloodline": "",
      "patron": "",
      "haunt_stats": ""
    },
    classLevels: {
      "spell_level_id": null,
      "spell_id": null,
      "sor": null,
      "wiz": null,
      "cleric": null,
      "druid": null,
      "ranger": null,
      "bard": null,
      "paladin": null,
      "alchemist": null,
      "summoner": null,
      "summoner_unchained": null,
      "witch": null,
      "inquisitor": null,
      "oracle": null,
      "antipaladin": null,
      "magus": null,
      "adept": null,
      "bloodrager": null,
      "shaman": null,
      "psychic": null,
      "medium": null,
      "mesmerist": null,
      "occultist": null,
      "spiritualist": null,
      "skald": null,
      "investigator": null,
      "hunter": null},
    spellTags: {
        "spell_tag_id": null,
        "spell_id": null,
        "acid": false,
        "air": false,
        "chaotic": false,
        "cold": false,
        "curse": false,
        "darkness": false,
        "death": false,
        "disease": false,
        "earth": false,
        "electricity": false,
        "emotion": false,
        "evil": false,
        "fear": false,
        "fire": false,
        "force": false,
        "good": false,
        "language_dependent": false,
        "lawful": false,
        "light": false,
        "mind_affecting": false,
        "pain": false,
        "poison": false,
        "shadow": false,
        "sonic": false,
        "water": false,
        "ruse": false,
        "draconic": false,
        "meditative": false
      },
    source: "",
    mythic: {
      "mythic_text": "",
      "augmented": ""
    },
    deity: {
      "deity_name": ""
    },
    school: "",
    subschool: {
      "subschool": ""
    },
    description: "",
    components: ""
  });

  useEffect(() => {
      axios.get(`https://${URL + PATH}spell?spell_id= ${spellId}`, {headers: {'Authorization': `Bearer ${AUTH}`}})
  .then((res) => {
    console.log(res.data)
    setSpellData(res.data);
    //TODO Maybe Make a spell specific comment!~
  }).catch((err) => { console.error(err) });
  }, [spellId]);

  useEffect(() => {
    console.log(spellData.mythic);
    formClassString(spellData.classLevels);
    formTagString(spellData.spellTags);


    console.log("Mythic Stuff!");
    console.log(spellData.mythic);

  }, [spellData])

  let navigate = useNavigate();

  let capitalize = (string) => {
    if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }



  let formClassString = (classLevels) => {
    let roleString = "";
    for (let role in classLevels) {
      let partyClass = role;
      if (role === "spell_level_id" || role === "spell_id") {
        partyClass = "";
      } else if (role === "wiz") {
        partyClass = "wizard"
      } else if (role === "sor") {
        partyClass = "sorcerer"
      } else if (role === "summoner_unchained") {
        partyClass = "summoner unchained"
      }
      if (roleString) {
        roleString += ", ";
      }
      if (partyClass != "" && classLevels[role]){
        roleString += `${capitalize(partyClass)} ${classLevels[role]}`
      }

    }
    setClassString(roleString);
  }

  let formTagString = (tags) => {
      let spellTagString = "";
    for (let tag in tags) {
      if (spellTagString) {
        spellTagString += ", "
      }
      if (tag === "mind_affecting") {
        spellTagString += "Mind Affecting"
      } else if (tag === "language_dependent") {
        spellTagString += "Language Dependent"
      }else {
        spellTagString += capitalize(tag);
      }
    }
    console.log("Tag String Updated!");
  setTagsString(spellTagString);
  }


  return (
    <div className="Spell">
      <div className="Spell-Header">
        <h2>{spellData.spellInfo.spell_name}</h2>
        <p>
          <b> School </b>
          {capitalize(spellData.school.spell_school)} {spellData.subschool ?
          <i className="Spell-Subschool">{capitalize(spellData.subschool.subschool)}</i>: null}
          {tagsString ? <i className="Spell-Tags">[{tagsString}]</i> : null}
          </p>
      </div>

      <div className="Spell-Class">
        <p><b> Level </b> {classString} </p>
      </div>

      <div className="Spell-Casting">
        <p className="divider">CASTING</p>
        <p>
          <b> Casting Time </b>
          {spellData.spellInfo.casting_time}
        </p>
        <p>
          <b> Components </b>
          {spellData.components ? spellData.components.component_string : "None"}
        </p>
      </div>

      <div className="Spell-Class">
        <p><b>Level</b> {classString}</p>
      </div>

      <div className="Spell-Effect">
        <p className="divider">EFFECT</p>
        {spellData.spellInfo.range ? <p><b> Range </b>{spellData.spellInfo.range}</p> : ""}
        {spellData.spellInfo.area ? <p><b> Area </b>{spellData.spellInfo.area}</p> : ""}
        {spellData.spellInfo.effect ? <p><b> Effect </b>{spellData.spellInfo.effect}</p> : ""}
        {spellData.spellInfo.target ? <p><b> Target </b>{spellData.spellInfo.target}</p> : ""}
        {spellData.spellInfo.duration ? <p><b> Duration </b>{spellData.spellInfo.duration}</p> : ""}
        {spellData.spellInfo.saving_throw ? <p><b> Saving Throw </b>{spellData.spellInfo.saving_throw}</p> : ""}
        {spellData.spellInfo.spell_resist ? <p><b> Spell Resistance </b>{spellData.spellInfo.spell_resist}</p> : ""}
        <p>{spellData.spellInfo.dismissible ? "Dismissible" : ""} {spellData.spellInfo.shapeable ? "Shapeable" : ""}</p>

      </div>

      <div className="Spell-Description">
        <p className="divider">DESCRIPTION</p>
        <p>{spellData.description.description}</p>
      </div>

      {spellData.mythic ? <div className="Spell-Mythic"> <p className="divider">MYTHIC</p> <p> {spellData.mythic.mythic_text} </p> <p> {spellData.mythic.augmented}</p> </div> : "" }


      <br/>
      <button type="button" className="btn" onClick={() => navigate('/')}><strong>Return</strong></button>
    </div>
  )
}

export default Spell;